import { TerminateBulkEmployees, ViewEmployees } from '../../pages';
import { employeeStore, userStore } from '../../stores';
import { MimaToastUtil } from '../../components';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { useFileUpload } from 'use-file-upload';
import { observer } from 'mobx-react';
import { EmployeeController } from '../../controllers';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const TerminateBulkEmployeesContainer = ({ closeModal, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(false);
	const [file, selectFile] = useFileUpload();
	const selectClick = () => {
		selectFile({ accept: '.csv' });
	};

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.EMPLOYEETERMINATE);

	const uploadClick = async () => {
		setLoading(true);
		let fileToSend;
		const formData = new FormData();
		if (typeof file.source === 'string') {
			fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
		}
		formData.append('emails', fileToSend);
		formData.append('status', 'TERMINATED');
		const {
			status,
			errorMessage,
		} = await EmployeeController.updateBulkEmployeesStatusCSV(formData);
		if (status === constant.Success) {
			setLoading(false);
			setUploaded(true);
		}else {
			MimaToastUtil.error({
				message: errorMessage,
			})
		}
	};


	return (
		<TerminateBulkEmployees
			closeModal={closeModal}
			uploaded={uploaded}
			uploadClick={uploadClick}
			file={file}
			selectClick={selectClick}
			loading={loading}
			setShowSurvey={setShowSurvey}
			needFeedback={needFeedback}
		/>
	);
};

export default observer(TerminateBulkEmployeesContainer);
